import { render, staticRenderFns } from "./display-field-button.vue?vue&type=template&id=ba756644&scoped=true&"
import script from "./display-field-button.ts?vue&type=script&lang=ts&"
export * from "./display-field-button.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-button.scss?vue&type=style&index=0&id=ba756644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba756644",
  null
  
)

export default component.exports